import init, { report3, report4 } from '@evideo/telemetry-core'
import store from '@/store'
import config from '@/config'

declare global {
  interface Window {
    Display?: {
      setSheetReportHooks?: (hooks: {
        report3: (value: string) => string
        report4: (value: string) => Promise<string>
      }) => void
    }
  }
}

// telemetry-core wasm read_token 约定：localStorage.teacher_token
const TEACHER_TOKEN_KEY = 'teacher_token'

let runtimePromise: Promise<void> | null = null

/**
 * 曲谱上报运行时初始化：init telemetry 加密库 + 给 display 注入加解密 hook。
 *
 * 曲谱加解密统一走 base64 字符串协议（report3 加密 / report4 解密），
 * Uint8Array<->string 适配由 display 内部完成，宿主只注入 telemetry 原生函数。
 *
 * 前置：须在 window.initSheetLib()（window.Display 就绪）之后调用。
 * 未登录（无 token）时跳过，保持明文链路。
 */
export const ensureSheetReportRuntime = (): Promise<void> => {
  if (runtimePromise) return runtimePromise
  const token = store.state.token
  if (!token) return Promise.resolve()
  // 写入 localStorage（telemetry wasm read_token 约定）
  localStorage.setItem(TEACHER_TOKEN_KEY, token)
  // resource-center 域名：institutionPlatform.baseURL（按 APP_ENV 映射，见 src/config/*）
  const domain = config.mainApps?.institutionPlatform?.baseURL
  if (!domain) return Promise.resolve()

  runtimePromise = (async () => {
    await init({ domain })
    const setHooks = window.Display?.setSheetReportHooks
    if (setHooks) {
      setHooks({ report3, report4 })
    }
  })().catch((error) => {
    runtimePromise = null
    console.error('[sheetReport] 初始化失败:', error)
  })
  return runtimePromise
}
